module.exports = __webpack_public_path__ + "static/media/pic_8.ba1342f4.png";